import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  loadArchivedCaraWorkspaceArtifacts,
  loadCaraWorkspaceArtifact,
  loadCaraWorkspaceArtifacts
} from '~/api/data/documents/queries';
import { loadHtmlDocumentTemplates } from '~/api/data/html-templates/queries';
import { DocumentPage, DocumentPreviewPage } from '~/pages/documents/documents';

// A child of each list that opens it, so closing it returns to that list.
export const documentPreviewRoute: RouteObject = {
  path: ':workspaceId/:artifactId/:version',
  loader: merge({
    caraWorkspaceArtifact: loadCaraWorkspaceArtifact,
    htmlDocumentTemplates: loadHtmlDocumentTemplates
  }),
  element: <DocumentPreviewPage />
};

export const documentRoutes: RouteObject[] = [
  {
    path: 'documents',
    loader: merge({
      caraWorkspaceArtifacts: loadCaraWorkspaceArtifacts
    }),
    element: <DocumentPage />,
    children: [documentPreviewRoute]
  },
  {
    path: 'documents/archived',
    loader: merge({
      caraWorkspaceArtifacts: loadArchivedCaraWorkspaceArtifacts
    }),
    element: <DocumentPage archived />,
    children: [documentPreviewRoute]
  }
];
